import React from "react";

// Styles
import MorningNotesRowContainer from "./MorningNotesRow.styles";

// React Router
import { useHistory } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCalendar,
    faUser,
    faUsers,
    faClock,
} from "@fortawesome/free-solid-svg-icons";
import { teamLabelDict } from "assets/data/lists";
import CommentCountCell from "../CommentCountCell/CommentCountCell";
import { GroupByEnum } from "../../../../screens/Company/MorningMeetingNotes/MorningMeetingNotes";

interface MorningNotesRowProps {
    data: any;
    groupBy: string | number;
}

const MorningNotesRow = ({ data, groupBy }: MorningNotesRowProps) => {
    const history = useHistory();
    const isGroupedByCompany = groupBy === GroupByEnum.BY_COMPANY;

    const redirectToNotes = () => {
        const url = isGroupedByCompany
            ? `/company/morning-meeting-company-notes?company_id=${data.id}`
            : `/company/morning-meeting-topic-classifier-notes?id=${data.topic_classifier_id}&name=${data.topic_classifier_value}`;
        history.push(url);
    };

    const getName = () => {
        return isGroupedByCompany
            ? data.company_name
            : data.topic_classifier_value;
    };

    const getCount = () => {
        return isGroupedByCompany ? data.comment_count : data.note_count;
    };

    return (
        <MorningNotesRowContainer onClick={redirectToNotes}>
            <div className="info">
                <div className="name">{getName()?.toUpperCase()}</div>
                <div className={"details"}>
                    {isGroupedByCompany && data.sector && (
                        <>
                            <Tooltip title={<h2>TEAM</h2>}>
                                <div className={"detail"}>
                                    <FontAwesomeIcon
                                        icon={faUsers}
                                        fixedWidth
                                    />
                                    <p className={"capitalize"}>
                                        {/* @ts-ignore */}
                                        {teamLabelDict[data.sector as any]}
                                    </p>
                                </div>
                            </Tooltip>
                            <Tooltip title={<h2>ANALYST</h2>}>
                                <div className={"detail"}>
                                    <FontAwesomeIcon icon={faUser} fixedWidth />
                                    <p className={"capitalize"}>
                                        {data.analyst}
                                    </p>
                                </div>
                            </Tooltip>
                            <Tooltip title={<h2>LAST VOTE DATE</h2>}>
                                <div className={"detail"}>
                                    <FontAwesomeIcon
                                        icon={faCalendar}
                                        fixedWidth
                                    />
                                    <p className={"capitalize"}>
                                        {data.last_vote_date}
                                    </p>
                                </div>
                            </Tooltip>
                            <Tooltip title={<h2>DAYS SINCE LAST COMMENT</h2>}>
                                <div className={"detail"}>
                                    <FontAwesomeIcon
                                        icon={faClock}
                                        fixedWidth
                                    />
                                    <p className={"capitalize"}>
                                        {data.days_since_last_comment} Days
                                    </p>
                                </div>
                            </Tooltip>
                        </>
                    )}
                    {!isGroupedByCompany && (
                        <>
                            <Tooltip title={<h2>LAST NOTE ADDED</h2>}>
                                <div className={"detail"}>
                                    <FontAwesomeIcon
                                        icon={faCalendar}
                                        fixedWidth
                                    />
                                    <p className={"capitalize"}>
                                        {data.last_note_added}
                                    </p>
                                </div>
                            </Tooltip>
                            <Tooltip title={<h2>DAYS SINCE LAST NOTE</h2>}>
                                <div className={"detail"}>
                                    <FontAwesomeIcon
                                        icon={faClock}
                                        fixedWidth
                                    />
                                    <p className={"capitalize"}>
                                        {data.days_since_last_note} Days
                                    </p>
                                </div>
                            </Tooltip>
                        </>
                    )}
                </div>
            </div>
            <CommentCountCell value={{ value: getCount() }} />
        </MorningNotesRowContainer>
    );
};
export default MorningNotesRow;
